import React, { useContext, useRef } from "react";
import { observer } from "mobx-react-lite";
import { format } from 'date-fns'

import {
  Button,
  Progress,
  Icon,
  Segment
} from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { ResumeStoreContext } from "../../stores/ResumeStore";
import "./Resume.css"
import GLGIcon from "../GLGIcon";
import { trackAction } from "../../tracking";
import OnboardingActions from "../../tracking/actions";

function checkFileType(file) {
  const types = [
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/msword",
    "applicatipon/doc",
    "applicatipon/docx",
    "application/pdf"
  ];

  const result = !!file.type ? types.indexOf(file.type) !== -1 : /\.(doc|docx|pdf)$/i.test(file.name);
  if(!result){
    trackAction(OnboardingActions.UploadFileTypeError, {fileType:file.type})
  }
  return result;
}

export default observer(function ResumeUploadView(props) {
  const resumeStore = useContext(ResumeStoreContext);
  const fileInputRef = useRef();
  const [t] = useTranslation();

  const onFile = e => {
    resumeStore.RESET();
    const file = e.target.files[0];
    if (checkFileType(file)) {
      resumeStore.uploadResume(file)
        .catch(() => {
          resumeStore.hasError = {
            status: t("please_try_again"),
            statusText: t("error_has_occured")
          };    
        });
    } else {
      resumeStore.hasError = {
        status: t("please_try_again"),
        statusText: t("incorrect_file_type")
      };
    }
  };

  return (
    <Segment basic style={{ padding: 0 }}>
      <Segment
        textAlign={"center"}
        style={{ margin: 0, padding: "40px" }}
      >
        <div>

          {(resumeStore.isLoading)  && (
            <Segment basic>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  color: "grey"
                }}
              >
                {resumeStore.uploadProcessType === "file"
                  ? t('uploading_resume')
                  : t('saving_url')
                }
                <span>
                  {resumeStore.fileprogress <= 100
                    ? `${resumeStore.fileprogress}%`
                    : t('processing_file')}
                </span>
              </div>
              <Progress
                percent={resumeStore.fileprogress}
                size="tiny"
                color="blue"
                autoSuccess
              />
            </Segment>
          )}
        </div>
        {((!resumeStore.isLoading) &&
        !resumeStore.resumeReceivedUTC &&
        !resumeStore.resumeURL)
          ? (
          <>
            <p>{t("upload_instructions")}</p>

            <div className="file-input-wrapper">
              <Button primary onClick={() => fileInputRef.current.click()}>
                {t("upload_button_label")}
              </Button>
              <input type="file" name="file" onChange={(e)=> onFile(e)} ref={fileInputRef}/>
            </div>

            {resumeStore.hasError && (
              <div className="input-error">
                {resumeStore.hasError.statusText}
              </div>
            )}
          </>
        ) : (
          !resumeStore.isLoading && (
            <>
              <p>{t("upload_instructions")}</p>
              <div className="resume-url-saved-ct">
                {resumeStore.resumeReceivedUTC ? (
                  <GLGIcon name="document-1" size="big"/>
                ) : (
                  <Icon name="linkify" size="large"/>
                )}{" "}
                <span className="label">
                  {
                    resumeStore.resumeURL
                    ? t("resume_url_saved")
                    : t("uploaded",{filename: resumeStore.resumeFileName})
                  }
                </span>
                <div className="resume-url-saved-x">
                  <Icon name={"close"} onClick={resumeStore.RESET}/>
                </div>
              </div>
              {
                resumeStore.resumeIsStale && <div><br/>{t("uploaded",{filename: format(resumeStore.resumeDateUTC, 'MMMM Do YYYY')})}</div>
              }
            </>
          )
        )}
      </Segment>
    </Segment>
  );
});
